export const validateSiret = (email) => {
    const regex = /^\d{14}$/;
    return regex.test(email);
  };